import React from 'react';
import { Container, Typography, Button, Box } from '@mui/material';
import { ErrorOutline as ErrorIcon } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

class ErrorBoundaryClass extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Blog Error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Container maxWidth="md" sx={{ py: 8, textAlign: 'center' }}>
          <ErrorIcon sx={{ fontSize: 80, color: 'error.main', mb: 3 }} />
          <Typography variant="h4" sx={{ mb: 2, color: 'error.main' }}>
            {this.props.language === 'hi' ? 'कुछ गलत हुआ है' : 'Something went wrong'}
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
            {this.props.language === 'hi' 
              ? 'पेज लोड करने में समस्या आई है। कृपया दोबारा कोशिश करें।'
              : 'There was a problem loading the page. Please try again.'
            }
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
            <Button
              variant="contained"
              component={Link}
              to="/blog"
            >
              {this.props.language === 'hi' ? 'ब्लॉग पर जाएं' : 'Go to Blog'}
            </Button>
            <Button
              variant="outlined"
              onClick={() => window.location.reload()}
            >
              {this.props.language === 'hi' ? 'रीलोड करें' : 'Reload'}
            </Button>
          </Box>
        </Container>
      );
    }

    return this.props.children;
  }
}

// Wrapper component that provides language context
const ErrorBoundary = ({ children }) => {
  const { language } = useLanguage();
  
  return (
    <ErrorBoundaryClass language={language}>
      {children}
    </ErrorBoundaryClass>
  );
};

export default ErrorBoundary;